import React from 'react';
import cx from 'classnames';

import { LoadingSpinner, IconErrorCircle } from '../..';

interface Props {
    canceled?: boolean;
    color: GradientProgressBarColor;
    handleCancel?(): void;
    Icon?: IconComponent;
    inProgressLabel: string;
    label: string;
    labelLines: 1 | 2;
    loadingSpinner: boolean;
}

export const ActiveBar = ({
    canceled,
    color,
    handleCancel,
    Icon,
    inProgressLabel,
    label,
    labelLines,
    loadingSpinner,
}: Props): JSX.Element => (
    <div className="px-4 flex justify-between items-center">
        {Icon && (
            <Icon addClasses="flex-none z-10" fillColor="white" width={24} />
        )}
        <div className="w-1/2 flex-none mx-2 text-white z-10 leading-tight">
            <div
                className={cx({
                    truncate: labelLines === 1,
                    'clamp-2-lines': labelLines === 2,
                })}
            >
                {label}
            </div>
        </div>
        <span className="flex-grow flex items-center justify-end z-10 leading-tight">
            <div
                className={cx({
                    truncate: labelLines === 1,
                    'clamp-2-lines-break-words': labelLines === 2,
                    'text-tertiary-400': color === 'aqua',
                    'text-white': color === 'purple-to-aqua',
                })}
            >
                {inProgressLabel}
            </div>
        </span>

        {loadingSpinner && (
            <div className="z-10 ml-2">
                <LoadingSpinner width={20} />
            </div>
        )}
        {!canceled && handleCancel && (
            <button
                type="button"
                className="z-10 ml-2 flex-none respond-to-mouse font-bold underline"
                onClick={handleCancel}
            >
                <IconErrorCircle width={13} fillColor="black" />
            </button>
        )}
    </div>
);
